import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "sizing"
    }}>{`Sizing`}</h1>
    <p>{`Used to set the width and height of elements on a page.`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class Reference`}</h2>
    <p>{`Our classes for width and height have both static values(in pixels) and fluid(in percentages). Sizing classes take on
the syntax of `}<inlineCode parentName="p">{`.{property}-{sizing value}`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "static-width"
    }}>{`Static Width`}</h2>
    <p>{`Elements can be given static values in pixels. The current set of static values are : 0, 10px, 20px, 30px and 40px.`}</p>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-0 </Name>
        <Output mdxType="Output">width: 0px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-10 </Name>
        <Output mdxType="Output">width: 10px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-20 </Name>
        <Output mdxType="Output">width: 20px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-30 </Name>
        <Output mdxType="Output">width: 30px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-40 </Name>
        <Output mdxType="Output">width: 40px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .wmx-40 </Name>
        <Output mdxType="Output">max-width: 40px;</Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
    <Sandbox.Preview>
        <div className="bs-auto br-no-repeat" style={{
          height: '100px'
        }}>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 c-grey-80 w-10 mr-2"> </div>
                <span>.w-10</span>
            </div>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 c-grey-80 w-20 mr-2"> </div>
                <span>.w-20</span>
            </div>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 c-grey-80 w-30 mr-2"> </div>
                <span>.w-30</span>
            </div>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 c-grey-80 w-40 mr-2"> </div>
                <span>.w-40</span>
            </div>
        </div>
    </Sandbox.Preview>
      <Sandbox.Code>
            <div className="w-10"></div>
            <div className="w-20"></div>
            <div className="w-30"></div>
            <div className="w-40"></div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "fluid-width"
    }}>{`Fluid Width`}</h2>
    <p>{`Fluid width values are represented in percentages. The values are in `}<strong parentName="p">{`multiples of 10`}</strong>{` and range from a minimum of 0 to a maximum of 100.`}</p>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-0 </Name>
        <Output mdxType="Output">width: 0px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-10p </Name>
        <Output mdxType="Output">width: 10%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-20p </Name>
        <Output mdxType="Output">width: 20%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-30p </Name>
        <Output mdxType="Output">width: 30%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-40p </Name>
        <Output mdxType="Output">width: 40%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-50p </Name>
        <Output mdxType="Output">width: 50%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-60p </Name>
        <Output mdxType="Output">width: 60%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-70p </Name>
        <Output mdxType="Output">width: 70%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-80p </Name>
        <Output mdxType="Output">width: 80%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-90p </Name>
        <Output mdxType="Output">width: 90%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .w-100p </Name>
        <Output mdxType="Output">width: 100%;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .wmx-70p </Name>
        <Output mdxType="Output">max-width: 70%;</Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example-1"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
    <Sandbox.Preview>
        <div className="bs-auto br-no-repeat" style={{
          height: '200px'
        }}>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 ba c-grey-80 w-10p pl-2 py-2">.w-10p </div>
                <div className="bg-primary-400 ba c-grey-80 w-90p pl-2 py-2">.w-90p </div>
            </div>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 ba c-grey-80 w-20p pl-2 py-2">.w-20p </div>
                <div className="bg-primary-400 ba c-grey-80 w-80p pl-2 py-2">.w-80p </div>
            </div>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 ba c-grey-80 w-30p pl-2 py-2">.w-30p </div>
                <div className="bg-primary-400 ba c-grey-80 w-70p pl-2 py-2">.w-70p </div>
            </div>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 ba c-grey-80 w-40p pl-2 py-2">.w-40p </div>
                <div className="bg-primary-400 ba c-grey-80 w-60p pl-2 py-2">.w-60p </div>
            </div>
            <div className="bs-solid d-flex mb-2">
                <div className="bg-primary-400 ba c-grey-80 w-50p pl-2 py-2">.w-40p </div>
                <div className="bg-primary-400 ba c-grey-80 w-50p pl-2 py-2">.w-60p </div>
            </div>
        </div>
    </Sandbox.Preview>
      <Sandbox.Code>
            <div className="w-10p"></div>
            <div className="w-20p"></div>
            <div className="w-30p"></div>
            <div className="w-40p"></div>
            <div className="w-50p"></div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "height"
    }}>{`Height`}</h2>
    <p>{`Height of an element is represented mostly in static values. These values are similar to our spacing values i.e. in multiples of 4
and can range from `}<strong parentName="p">{`0-15(0 to 60px)`}</strong>{`.`}</p>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-0 </Name>
        <Output mdxType="Output">height: 0px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-1 </Name>
        <Output mdxType="Output">height: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-2 </Name>
        <Output mdxType="Output">height: 8px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-3 </Name>
        <Output mdxType="Output">height: 12px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-4 </Name>
        <Output mdxType="Output">height: 16px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-5 </Name>
        <Output mdxType="Output">height: 20px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-6 </Name>
        <Output mdxType="Output">height: 24px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-7 </Name>
        <Output mdxType="Output">height: 28px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-8 </Name>
        <Output mdxType="Output">height: 32px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-9 </Name>
        <Output mdxType="Output">height: 36px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-10 </Name>
        <Output mdxType="Output">height: 40px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-11 </Name>
        <Output mdxType="Output">height: 44px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-12 </Name>
        <Output mdxType="Output">height: 48px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-13 </Name>
        <Output mdxType="Output">height: 52px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-14 </Name>
        <Output mdxType="Output">height: 56px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-15 </Name>
        <Output mdxType="Output">height: 60px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .h-100p </Name>
        <Output mdxType="Output">height: 100%;</Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example-2"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="bs-auto br-no-repeat" style={{
          height: "100%"
        }}>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-1</span>
        <div className="bg-primary-400 c-grey-80 h-1 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-2</span>
        <div className="bg-primary-400 c-grey-80 h-2 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-3</span>
        <div className="bg-primary-400 c-grey-80 h-3 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-4</span>
        <div className="bg-primary-400 c-grey-80 h-4 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-5</span>
        <div className="bg-primary-400 c-grey-80 h-5 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-6</span>
        <div className="bg-primary-400 c-grey-80 h-6 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-7</span>
        <div className="bg-primary-400 c-grey-80 h-7 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-8</span>
        <div className="bg-primary-400 c-grey-80 h-8 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-9</span>
        <div className="bg-primary-400 c-grey-80 h-9 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-10</span>
        <div className="bg-primary-400 c-grey-80 h-10 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-11</span>
        <div className="bg-primary-400 c-grey-80 h-11 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-12</span>
        <div className="bg-primary-400 c-grey-80 h-12 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-13</span>
        <div className="bg-primary-400 c-grey-80 h-13 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-14</span>
        <div className="bg-primary-400 c-grey-80 h-14 mr-2"> </div>
      </div>
      <div className="bs-solid d-flex flex-column mb-2">
        <span>.h-15</span>
        <div className="bg-primary-400 c-grey-80 h-15 mr-2"> </div>
      </div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="h-1" />
    <div className="h-2" />
    <div className="h-3" />
    <div className="h-4" />
    <div className="h-5" />
    <div className="h-6" />
    <div className="h-7" />
    <div className="h-8" />
    <div className="h-9" />
    <div className="h-10" />
    <div className="h-11" />
    <div className="h-12" />
    <div className="h-13" />
    <div className="h-14" />
    <div className="h-15" />
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      